import { Logo, Navbar, Nav } from '@bphxd/ds-core-react';

import React from 'react';

const GeoNavbar = (props: { username: string }) => {
  //console.log(JSON.stringify(props.user));

  return (
    <>
      <Navbar divider="border" className="header">
        <Navbar.Brand href="/" className={`me-auto me-md-5`}>
          <Logo className="mx-n3" />
          <span className="ms-5 text-black">
            Mauritania & Senegal GTA Hub to FLNG mooring tensions
          </span>
        </Navbar.Brand>

        <div className="className={`ms-auto d-none d-md-flex align-items-center`}">
          <Nav className="flex-row me-4" navbar>
            <Nav.Item className='px-4'>
              <Nav.Link active>
                <span className="text-black">
                  <a href="https://rtvis-eh.bpweb.bp.com/PIVision/#/Displays/223857/GTA-Table-Of-Contents?tz=UTC" data-id="PI Vision" data-parentid="Link">
                    PI Vision
                  </a>
                </span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className='px-4'>
              <Nav.Link active>
                <span className="text-black">
                  <a href="mailto:GDataWorxGeospatialRSSolutions@bp.com?subject=GTA Down-Manning Support Enquiry" data-id="Contact Us" data-parentid="Link">
                    Contact Us
                  </a>
                </span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className='px-4'>
              <Nav.Link href="#" onClick={function noRefCheck() {}}>
                {props.username}
              </Nav.Link>
            </Nav.Item>
            {/* <WorldPin48 color="#15AD5C" fill="#FFEE5C" /> */}
          </Nav>
        </div>
        {/* <button
          aria-label="Toggle navigation"
          className="btn-close-inline d-lg-none ms-4"
          onClick={function noRefCheck() {}}
          type="button"
        >
          <span aria-hidden="true">
            <SvgHamburger32 />
          </span>
        </button> */}
      </Navbar>
      {/* <React.Fragment key=".1">
        <Offcanvas
          backdropClassName="offcanvas-backdrop-sidebar"
          className="offcanvas-sidebar pt-11"
          direction="top"
          style={{
            height: '150px',
          }}
          toggle={function noRefCheck() {}}
          zIndex="auto"
        >
          <InputGroup className="input-group-merge px-4 py-3">
            <Input className="form-control-prepended" placeholder="Search..." />
            <div className="input-group-prepend">
              <InputGroup.Text>
                <SvgSearch24 />
              </InputGroup.Text>
            </div>
          </InputGroup>
        </Offcanvas>
        <Offcanvas
          backdropClassName="offcanvas-backdrop-sidebar"
          className="offcanvas-sidebar pt-11"
          toggle={function noRefCheck() {}}
          zIndex="auto"
        >
     
        </Offcanvas>
      </React.Fragment> */}
    </>
  );
};

export default GeoNavbar;
